import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { DataService_ReminderAlertSetup } from "../shared/data.service";
import { StationReminderAlertPersonRemoveRequest } from "../shared/StationReminderAlertPersonRemoveRequest";
import { StationReminderAlertPersonToggleRequest } from "../shared/StationReminderAlertPersonToggleRequest";
import { AddScanReminderPersonComponent } from "./add-scan-reminder-person/add-scan-reminder-person.component";

@Component({
	selector: "caass-scan-reminder-person-table",
	templateUrl: "./scan-reminder-person-table.component.html",
	styleUrls: ["./scan-reminder-person-table.component.css"],
})
export class ScanReminderPersonTableComponent implements OnInit {
	constructor(
		// private userService: UserService,
		private ReminderAlertPersonService: DataService_ReminderAlertSetup,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		// this.user = this.userService.getCurrentUser();

		this.loadPerson();
	}

	ngOnChanges() {
		this.loadPerson();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@ViewChild("mydt") mydt: Table;

	@Input() SelectedStationReminderAlert: any;
	// @Input() StationReminderAlertID: number;
	@Output() Updated: EventEmitter<any> = new EventEmitter();

	ToggleText: string = "Deactivate Reminder";
	Processing: boolean = false;

	ShowInfo: boolean = false;

	///////////////
	// Built-In
	///////////////

	// user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any;
	lstPerson: any = [];

	//Filter lists
	lstPersonTypeDesc: any = [];
	lstAlreadyPlayedDesc: any = [];
	lstActiveDesc: any = [];
	lstGroupName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ID", header: "Student/Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Person Type" },
		// { field: 'AlreadyPlayedDesc', header: 'Already Played' },
		// { field: 'ActiveDesc', header: 'Active' },
		// { field: 'c_date', header: 'Last Updated' },
	];

	cols2: any = [
		{ field: "c_dateDesc", header: "Last Updated" },
		{ field: "GroupName", header: "Assigned by Group" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPerson() {
		this.errorMessage = "";
		this.SelectedPersons = [];

		if (this.SelectedStationReminderAlert == undefined) {
			this.lstPerson = [];
			return;
		}

		this.loading = true;

		var result = this.ReminderAlertPersonService.StationReminderAlertPersonInfoSelectList(this.SelectedStationReminderAlert.StationReminderAlertID);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.PersonTypeDesc))).sort();
				this.lstAlreadyPlayedDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.AlreadyPlayedDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
				this.lstGroupName = Array.from(new Set(this.lstPerson.map((item: any) => item.GroupName))).sort();

				this.UpdateFilters();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		// let popup_WidthInt = window.innerWidth - 64;
		// let popup_Width = popup_WidthInt.toString() + "px";

		var ref = this.dialogService.open(AddScanReminderPersonComponent, {
			header: "Add",
			width: "fit-content",
			closable: false,
			data: {
				//INSERT Custom Data here
				StationReminderAlertID: this.SelectedStationReminderAlert.StationReminderAlertID,
				Message: this.SelectedStationReminderAlert.Message,
				MessageFontColor: this.SelectedStationReminderAlert.MessageFontColor,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
				this.Updated.emit(true);
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedPersons.length == 0) {
			this.errorMessage = "Select students to unassign the reminder";
			return;
		}

		this.confirmationService.confirm({
			key: "personconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"You are about to remove " +
				this.SelectedPersons.length +
				" " +
				(this.SelectedPersons.length == 1 ? "person" : "people") +
				' from the reminder "' +
				this.SelectedStationReminderAlert.Message +
				'". Do you want to continue?',
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
		});
	}

	FinishDelete() {
		this.Processing = true;

		//Call SP
		var lstPIDs: number[] = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: StationReminderAlertPersonRemoveRequest = {
			StationReminderAlertID: this.SelectedStationReminderAlert.StationReminderAlertID,
			lstPersonIDs: lstPIDs,
		};

		var result = this.ReminderAlertPersonService.StationReminderAlertPersonRemove(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					this.SelectedPersons = [];
					this.loadPerson();
					this.Updated.emit(true);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "person",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the selected students",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onToggleAll(changeTo) {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedStationReminderAlert == undefined) {
			return;
		}

		//
		// Reset?
		//
		if (changeTo == 1) {
			this.confirmationService.confirm({
				key: "personreset",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message:
					"You are about to activate the reminder for the selected students. Do you want to reset whether or not they received the reminder already?",
				header: "Reset Already Played",
				icon: "fa",
				accept: () => {
					this.FinishToggleAll(changeTo, true);
				},
				reject: () => {
					this.FinishToggleAll(changeTo, false);
				},
			});
		} else {
			this.FinishToggleAll(changeTo, false);
		}
	}

	FinishToggleAll(changeTo, reset) {
		this.Processing = true;

		var lstPIDs: number[] = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: StationReminderAlertPersonToggleRequest = {
			StationReminderAlertID: this.SelectedStationReminderAlert.StationReminderAlertID,
			Active: changeTo,
			ResetAlreadyPlayed: reset == true ? 1 : 0,
			lstPersonIDs: lstPIDs,
		};

		//Call SP
		var result = this.ReminderAlertPersonService.StationReminderAlertPersonToggle(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					this.SelectedPersons = [];
					this.loadPerson();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "person",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (changeTo == true ? "activate" : "deactive") + " the reminder for the selected students",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.Processing == true;
	}
	UpdateFilters() {
		this.mydt.filters.ActiveDesc["value"] = "Active"; // Default To 'Active'
	}
	////////////////////////////////////////////
}
